var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.774 36.261a4.253 4.253 0 0 1 0 5.975l-3.5 3.54a.75.75 0 1 1-1.066-1.056l3.5-3.537a2.752 2.752 0 0 0 0-3.869l-3.99-4.038a.746.746 0 0 1 .006-1.061.715.715 0 0 1 1.031.006zM0 38.17V33.5A1.5 1.5 0 0 1 1.5 32h4.672a1.994 1.994 0 0 1 1.412.586l5.25 5.248a2 2 0 0 1 0 2.831l-4.169 4.167a2 2 0 0 1-2.831 0l-5.248-5.25A1.994 1.994 0 0 1 0 38.17zm3.5-3.67a1 1 0 1 0 1 1 1 1 0 0 0-1-1z",
    fill: "currentColor",
    transform: "translate(0 -30.998)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceListIcon);
export default __webpack_public_path__ + "static/media/price-list-icon.f29e7002e17df38755bd44570bc2594e.svg";
export { ForwardRef as ReactComponent };